import type { ReactNode } from 'react';
import { testIdAttr } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';
import './Divider.css';

export interface DividerProps {
  /** The label in the gap. Without it the rule runs edge to edge. */
  children?: ReactNode;
  /** start — year on the left, rule to the right. Default is centred. */
  align?: 'center' | 'start';
  testId?: string;
}

/** A rule between two parts of a screen, labelled — “or” — or a year. */
export function Divider({ children, align = 'center', testId }: DividerProps) {
  const className = align === 'start' ? 'divider divider--start' : 'divider';
  return (
    <div className={className} role="separator" {...testIdAttr(testId)}>
      {children ? (
        <Typography as="span" role="meta/helper">
          {children}
        </Typography>
      ) : null}
    </div>
  );
}
